<template>
  <offer-service-form />
</template>

<script>
import OfferServiceForm from "./OfferServiceForm.vue";

export default {
  components: { OfferServiceForm },
};
</script>
